import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ApolloSpinnerComponent } from './apollo-spinner.component';

@NgModule({
  declarations: [ApolloSpinnerComponent],
  imports: [CommonModule, MatProgressSpinnerModule],
  exports: [ApolloSpinnerComponent],
})
export class ApolloSpinnerModule {}
